/**
 * Dependências externas
 */
import get from 'lodash/fp/get';
import partial from 'lodash/fp/partial';

const getHttpStatusError = partial(get, ['response.status']);

export default getHttpStatusError;
